import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
    L10N_CONFIG,
    L10N_LOCALE,
    L10nConfig,
    L10nLocale,
    L10nTranslatePipe,
    L10nTranslationService
} from 'angular-l10n';

import { HttpClient } from "@angular/common/http";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FlexModule, MediaObserver } from "@ngbracket/ngx-layout";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ReplaySubject, Subject } from "rxjs";
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { AuthService } from "../../shared/auth.service";
import { BreadcrumbService } from "../../shared/breadcrumb/breadcrumb.service";
import { ErrorHelper } from "../../shared/error.helper";
import { LoggerService } from "../../shared/logger.service";
import { SessionService } from "../../shared/session.service";
import { OaseDeleteDialogComponent } from "../immerdrin/oase.delete.component";
import { RestServiceImpl } from "../immerdrin/rest.service.impl";
import { RestService } from "../immerdrin/rest.service.interface";
import { SelectFilterUtil } from "../immerdrin/select-filter.util";
import { Tabelle } from "../immerdrin/tabelle/tabelle";
import { DataTablePipeKernrecht } from "../kernrecht/datapipekernrecht";
import { Kernrecht } from "../kernrecht/kernrecht.model";
import { KerngruppeInsertEditComponent } from "./kerngruppe.insertEdit.component";
import { Kerngruppe } from "./kerngruppe.model";

const PATH_FILE = 'app/protected/gruppen/kerngruppe/kerngruppe.component.ts';
const OBJ_LNG_NAME = 'kerngruppe';
const BACKEND_PATH_PREFIX = 'gruppe/';

@Component({
    selector: 'oase-kerngruppe',
    templateUrl: './kerngruppe.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,
	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, DataTablePipeKernrecht, NgxMatSelectSearchModule,
		ReactiveFormsModule, FlexModule]

})
export class KerngruppeComponent extends Tabelle<Kerngruppe> {

    rechte: Kernrecht[] = new Array<Kernrecht>();
    _selectsuche: string[] = new Array<string>();

    public filterCtl: FormControl = new FormControl();
    public selectCtl: FormControl = new FormControl();
    /** list of rechts filtered by search keyword */
    public filteredRechts: ReplaySubject<Kernrecht[]> = new ReplaySubject<Kernrecht[]>(1);

    /** Subject that emits when the component has been destroyed. */
    private _onDestroy = new Subject<void>();

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public breadcrumbService: BreadcrumbService,
        public snackBar: MatSnackBar,
        public authService: AuthService,
        public apiConfigService: APIConfigService, public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,        // public dragulaService: DragulaService,
        public dialog: MatDialog,
		public media: MediaObserver,
        public changeDetectorRef: ChangeDetectorRef,
        public sessService: SessionService,
        public title: Title,
        public _logger: LoggerService) {

        super( route, router, breadcrumbService, snackBar,
            authService, http, translation, dialog, media, changeDetectorRef,
            sessService, title, _logger, apiConfigService, {
                OBJ_LNG_NAME: OBJ_LNG_NAME,
                BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
                ROUTE_NAME: "/kernrecht",
                PATH_FILE: PATH_FILE,
                DEFAULT_SORT_COLUMN: "sprachschluessel",
                extraDataForAdding: { }
            }
        );
        this.displayedColumns = ['uebersetzung', 'sprachschluessel', 'kernrecht', 'admin'];
    }


    setDerivedColumns() {

        this.derivedColumns.push(
            {   key: "uebersetzung",
                internalName: "md2DataTableSort_Sprachschluessel",
                f: (row: any) => { this._selectsuche[row.id] = ""; return this.translation.translate('kerngruppe.' + row.sprachschluessel) }
            }
        )
    }


    extraInit() {
        this.getKernRechte();
        super.extraInit();
    }

    createNewElement() {
        return new Kerngruppe();
    }

    loeschenSpalteName() {
        return "md2DataTableSort_Sprachschluessel";
    }

    getApiParams() {
        return "seite";
    }

    vorHinzufuegen(element) {
        element.rechte = this.rechte;
    }

    zeigeLoeschenMaske(element: any) {
        this._zeigeLoeschenMaske(element, OaseDeleteDialogComponent);
    }

    zeigeHinzufuegenMaske() {
        this._zeigeHinzufuegenMaske(KerngruppeInsertEditComponent);
    }

    zeigeBearbeitenMaske(element) {
        element.rechte = this.rechte;
        this._zeigeBearbeitenMaske(element, KerngruppeInsertEditComponent);
    }

    private getKernRechte() {
        this._logger.log(PATH_FILE + ' - getKernRechte Begin');
        this.ladedaten = true;
        this.http.get<Kernrecht[]>(this.apiConfigService.REST_API_BASE() + 'recht/liste').subscribe({
            next: (res) => {
                this.ladedaten = false;
                this.rechte = res;
            },
            error: (err) => {
                this.ladedaten = false;
                ErrorHelper.handleError(err,"Fehler beim holen die Rechte",this._logger, this.translation);
            },
            complete: () => {
                this.ladedaten = false;
                this._logger.log(PATH_FILE + ' - getKernRechte FERTIG');
                this._logger.log(PATH_FILE + ' - getKernRechte kerngruppen: ', this.rechte)
            }
        });
    }

    behandleRechteaenderungen(kerngruppe) {
        this._logger.log(PATH_FILE + ' - behandleRechteaenderungen BEGIN mit kerngruppe: ', kerngruppe);
        let snacknachricht = this.translation.translate('allgemein.daten.geändert', { typ: this.translation.translate('kernrecht.typ') });
        this.speichern(kerngruppe, snacknachricht, false); // false ... Tabelle nicht neu laden
    }

    // such comparison is needed for mat-select
    compareMitId(item1, item2) {
        return item1 && item2 ? item1.id === item2.id : item1 === item2;
    }

    initRecht(row) {
      SelectFilterUtil.initFilter(this.rechte, row, (recht, search) => { return recht.sprachschluessel.toLowerCase().indexOf(search) > -1 })
      return true;
    }

}
